import React from 'react';

import { useTranslation } from "react-i18next";
import i18n from '../../i18n';
import Flag from './Flag';

const LanguajeFlags = (props) => {
    const { t } = useTranslation();

    const flagEsUrl = 'ES';
    const flagEnUrl = 'EN';

    const handleChangeLanguage = (languaje) => {
        i18n.changeLanguage(languaje)
    }

    return (
        <>
            <div className="user-action-dropdown-item" style={{cursor: 'pointer'}} onClick={() => handleChangeLanguage("es")}>
                <div className="user-action-icon d-flex">     
                    <Flag inputParam_Code={flagEsUrl} /> {t('data-lang-lbl-spanish')}
                </div>
            </div>      
            <div className="user-action-dropdown-item" style={{cursor: 'pointer'}} onClick={() => handleChangeLanguage("en")}>
                <div className="user-action-icon d-flex">     
                    <Flag inputParam_Code={flagEnUrl} /> {t('data-lang-lbl-english')}
                </div>
            </div>
        </>
    )
}
export default LanguajeFlags



